var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('navbar',{attrs:{"lightTheme":true,"blogpost":true}}),_c('div',{attrs:{"id":"raw"},domProps:{"innerHTML":_vm._s(_vm.raw3)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }